import { Stack } from '@mui/material';
import React from 'react';

import { FolderIcon } from '@/shared/assets/icons/folder-icon';
import { TruncatedText } from '@/shared/components/ui/truncated-text/truncated-text';
import { TGroupSelectLabelProps } from '@/shared/features/groups/components/group-select/group-select-label/group-select-label.types';

export const GroupSelectLabel = ({
  option,
}: TGroupSelectLabelProps<string>) => {
  return (
    <Stack direction="row" gap="0.5rem" alignItems="center" width="100%">
      <FolderIcon variant="primary" />
      <TruncatedText variant="p8" text={option.label} maxLength={32} />
    </Stack>
  );
};
